/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Calendar_ReadInputs */

const es_tools_calendar_read = /** @type {(inputs: Tools_Calendar_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leyendo evento de Google...`)
};

const en_tools_calendar_read = /** @type {(inputs: Tools_Calendar_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading Google event...`)
};

/**
* | output |
* | --- |
* | "Reading Google event..." |
*
* @param {Tools_Calendar_ReadInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_calendar_read = /** @type {((inputs?: Tools_Calendar_ReadInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Calendar_ReadInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_calendar_read(inputs)
	return en_tools_calendar_read(inputs)
});
export { tools_calendar_read as "tools.calendar.read" }